import { PropsWithChildren } from "react";
import { clsx } from "clsx";

interface PopoverContentProps {
	className?: string;
}

export const PopoverContent = ({ children, className }: PropsWithChildren<PopoverContentProps>) => {
	return (
		<div
			className={clsx(
				className,
				"p-2 bg-base-200  border-black/20 drop-shadow-md shadow-outline border-2 shadow-black rounded",
			)}
		>
			{children}
		</div>
	);
};
